import { FC, memo } from "react";
import { useSectionPad } from "./section";

interface SectionHeaderProps {
    children?: React.ReactNode
}

const SectionHeader: FC<SectionHeaderProps> = ({ children }) => {
    const padX = useSectionPad()
    return (
        <div className={`flex flex-row justify-between items-center w-full ${padX ? '' : 'px-2 lg:px-0'}`}>
            {children}
        </div>
    )
}

export default memo(SectionHeader)
